import client from './requestclient';

const recruitRealtor = {
    add: async (body) => {
        return await client({URL_PATH: 'recruitrealtor', method: 'POST', body: body})
    }
}

export default recruitRealtor;